<style scoped>

/* Live Feed CSS */
a.txtlink:hover{
    text-decoration: none;
}

pre.code-pre{
    background: #f3f3f3;
    max-height: 300px;
}

.meta {
    color: #777;
    font-size: .85em;
}

.meta-bit {
    color: #333;
    font-weight: bold;
}

>>>span.badge.nohover{
    font-size: 10px;
    text-align: center;
    min-height: 1.1rem;
}

span.badge.nohover.badge-light.badge-pill{
    background-color: #d1e3ff !important;
}

span.badge.nohover.yara-pill.badge-secondary.badge-pill{
    background-color: #7400c6 !important;
}

.table-hover tbody tr:hover {
    background-color: rgba(0, 0, 0, 0.075);
}
.badge.badge-primary.badge-pill{
    font-size: .7rem;
    background-color: #bfbfbf;
}
.badge.badge-primary.badge-pill:hover{
    /*background-color: #0062cc;*/
    background-color: #bfbfbf;
    cursor: pointer;
}

div#lf-tip{
/*    border-bottom-color: #000 !important;
    border-bottom-style: solid;
    border-bottom-width: 4px;
    border-top-color: #000 !important;
    border-top-style: solid;
    border-top-width: 4px;
    color: #000;
    text-align: center;
    background-color: #fff !important;
    border-radius: 0.25rem;*/
}
#lf-info.fa.fa-info-circle:hover{
    cursor: pointer;
}
span.badge.nohover.autoit-pill.badge-secondary.badge-pill{
    background-color: #5c82ac;
    font-weight: normal;
    font-size: 10px;
}
span.badge.nohover.downloader-pill.badge-secondary.badge-pill{
    background-color: #28a745;
    font-weight: normal;
    font-size: 10px;
}
span.badge.nohover.malpedia-pill.badge-secondary.badge-pill{
    background-color: #ff6a23;
    font-weight: normal;
    font-size: 10px;
}
span.badge.nohover.deepmatch-pill.badge-secondary.badge-pill{
    background-color: #701fb9;
    font-weight: normal;
    font-size: 10px;
}
span.badge.nohover.children-pill.badge-secondary.badge-pill{
    background-color: #bfbfbf;
    font-weight: normal;
    font-size: 10px;
}
span.badge.nohover.nochildren-pill.badge-secondary.badge-pill{
    background-color: #f1d543;
    font-weight: normal;
    font-size: 10px;
}

>>>thead{
    line-height: 1;
    font-size: 0.9rem;
}
>>>tbody{
    line-height: 1;
    font-size: 0.9rem;
}
h1#info-page{
    font-size:45px;
    font-weight:300;
    height:54px;
    line-height:54px;
}
.vl {
  border-left: 1px solid;
  border-left-color: rgba(0, 0, 0, 0.125);
  height: 50px;
}
a#bt-scroll.btn.btn-secondary.btn-block{
    min-width: 1120px;
    background-color: #ffffff;
    border-color: #ffffff;
    color: #bcbec0;
}
a#bt-scroll.btn.btn-secondary.btn-block:hover{
    background-color: #fdfdff;
    box-shadow: 0 0 0 0rem rgba(108, 117, 125, 0.5);
}
a#bt-scroll.btn.btn-secondary.btn-block:focus{
    box-shadow: 0 0 0 0rem rgba(108, 117, 125, 0.5);
}
a#bt-scroll-dissable.btn.btn-secondary.btn-block{
    min-width: 1120px;
    background-color: #ffffff;
    border-color: #ffffff;
    color: #bcbec0;
}
a#bt-scroll-dissable.btn.btn-secondary.btn-block:hover{
    background-color: #ffffff;
    cursor: default;
    box-shadow: 0 0 0 0rem rgba(108, 117, 125, 0.5);
}
a#bt-scroll-dissable.btn.btn-secondary.btn-block:focus{
    box-shadow: 0 0 0 0rem rgba(108, 117, 125, 0.5);
}
.blinking{
    animation:blinkingText 2s infinite;
}
@keyframes blinkingText{
    0%{     color: rgba(188, 190, 192, 0.1);  }
    5%{     color: rgba(188, 190, 192, 0.2);  }
    10%{    color: rgba(188, 190, 192, 0.3);  }
    15%{    color: rgba(188, 190, 192, 0.4);  }
    20%{    color: rgba(188, 190, 192, 0.5);  }
    25%{     color: rgba(188, 190, 192, 0.6);  }
    30%{   color: rgba(188, 190, 192, 0.7);    }
    35%{   color: rgba(188, 190, 192, 0.8);    }
    40%{   color: rgba(188, 190, 192, 0.9);    }
    45%{   color: rgba(188, 190, 192, 1);    }
    50%{   color: rgba(188, 190, 192, 0.9);    }
    55%{   color: rgba(188, 190, 192, 0.8);    }
    60%{   color: rgba(188, 190, 192, 0.7);    }
    65%{   color: rgba(188, 190, 192, 0.6);    }
    70%{   color: rgba(188, 190, 192, 0.5);    }
    75%{   color: rgba(188, 190, 192, 0.4);    }
    80%{   color: rgba(188, 190, 192, 0.3);    }
    85%{   color: rgba(188, 190, 192, 0.2);    }
    90%{   color: rgba(188, 190, 192, 0.1);    }
    95%{   color: rgba(188, 190, 192, 0);    }
    100%{   color: rgba(188, 190, 192, 0);    }
}
</style>

<template>
<div class="container">
    <template v-if="!isMobile()">
        <div class="row">
            <div class="col-sm-6">
                <h1 id="info-page">Live Feed
                    <template v-if="feedLoading">
                        <small style="color:#b4bcc2;font-size:0.9rem;">
                            <b-spinner small label="Loading..."></b-spinner>
                        </small>
                    </template>
                </h1>
            </div>
        </div>
        <template v-if='Object.keys(feedResults).length'>
            <div class="row">
                    <div class="col-sm-12">
                    <b-card
                        no-body
                        title=""
                        img-top
                        id="upload-settings"
                        class="mb-2"
                        style="max-width: 70rem;min-width: 70rem;"
                    >
                    <template v-if='Object.keys(accessData).length && 
                                (
                                accessData.roles.includes("feed") ||
                                accessData.roles.includes("admin") 
                                )'>
                        <b-card-body style="padding: 10px;">
                            <b-card-text  v-if='Object.keys(accessData).length'>
                                    <b-button
                                        variant="outline-secondary"
                                        size="sm"
                                        style="margin: 5px;font-size: 11px;"
                                        v-for="(yara, idx) in Object.keys(yaraHits)"
                                        :key="idx"
                                        v-on:click="setYaraFilter(yara)" 
                                        :pressed="yaraFilter === yara"
                                    >
                                        {{yara}} | {{yaraHits[yara]}}
                                    </b-button>
                            </b-card-text>
                        </b-card-body>
                    </template>
                    <template v-else>
                        <b-card-body style="padding: 10px;">
                            <b-card-text>
                                <b-row>
                                    <b-col >
                                        <div style="font-size: 80%; font-weight: 400;color: #777;">
                                            This feed only represents a small subset of samples processed by UNPACME and is intended for demonstration purposes only.
                                            The feed is refreshed once an hour and trails behind the live results by about five hours. 
                                            For full feed access see our available <a id="link" href="/plans">plans</a>.
                                        </div>
                                    </b-col>
                                </b-row>
                            </b-card-text>
                        </b-card-body>
                    </template>
                    </b-card>
                </div>

            </div>
            <template v-if='Object.keys(accessData).length && 
                                (
                                accessData.roles.includes("feed") ||
                                accessData.roles.includes("admin") 
                                )'>
                <div class="row">
                    <div class="col-sm-10">
                        <table class="table table-hover" style="max-width: 70rem;min-width: 70rem;">
                          <thead>
                            <tr>
                              <th scope="col">Submitted</th>
                              <th scope="col">Sample</th>
                              <th scope="col">Children</th>
                              <th scope="col">Tags</th>
                              <th scope="col"></th>
                            </tr>
                          </thead>
                          <tbody>
                            <tr class="meta" v-for="(sample, index) in feedResults" :key="index" >
                                <td style="line-height: 1.5;">
                                    <template v-if='sample.created'>
                                        {{ sample.created | moment("DD/MM/YYYY")  }}
                                        <br>
                                        {{ sample.created | moment("HH:mm:ss")  }}
                                    </template>
                                </td>
                                <!--td class="meta-bit"><b>{{ sample.sha256 }}</b></td-->
                                <td><a class="txtlink"  target="_blank" :href="'/results/'+sample.id"><b class="txtlink">{{ sample.submission_sha256 }}</b></a></td>
                                <td>
                                    <template v-if="sample.child_count == 0 &&
                                                    !sample.downloader &&
                                                    !Object.keys(sample.malwareid).length">
                                        <b-badge pill style="pointer-events:none" class="nohover nochildren-pill"><b>{{sample.child_count}}</b></b-badge>
                                    </template>
                                    <template v-else>
                                        <b-badge pill style="pointer-events:none" class="nohover children-pill"><b>{{sample.child_count}}</b></b-badge>
                                    </template>
                                </td>
                                <td style="line-height: 1.5;">
                                    <template v-if="sample.autoit">
                                        <b-badge pill style="pointer-events:none" v-bind:key="sample.autoit.id" class="nohover autoit-pill"><b>AutoIt</b></b-badge>
                                    </template>
                                    <template v-if="sample.downloader">
                                        <b-badge pill style="pointer-events:none" v-bind:key="sample.downloader.id" class="nohover downloader-pill"><b>Network Dropper</b></b-badge>
                                    </template>
                                    <template v-for="malwareidHit in sample.malwareid">
                                        <template v-if="malwareidHit.type =='malpedia'">
                                            <b-badge pill style="pointer-events:none" v-bind:key="malwareidHit.id" class="nohover malpedia-pill"><b>{{malwareidHit.match}}</b></b-badge>
                                        </template>
                                    </template>
                                    <template v-for="deepMatchHit in sample.deepmatch">
                                        <b-badge pill style="pointer-events:none" v-bind:key="deepMatchHit.id"  class="nohover deepmatch-pill"><b>{{deepMatchHit.label}}</b></b-badge>
                                    </template>
                                </td>
                              <td>
                                <b-badge variant="primary"
                                    v-on:click="bulkDownload(sample.id)"
                                    pill
                                    v-b-popover.hover.topright.html="'Feature available soon'"
                                    >
                                     Bulk Download <i class="fa fa-cloud-download"></i>
                                </b-badge>
                              </td>
                            </tr>
                          </tbody>
                        </table>
                        <template v-if="feedMore">
                            <template v-if="!feedLoading">
                                <b-btn block href="#" id="bt-scroll" v-on:click="yaraFilter ? getYaraFeed() : getPrivateFeed()" >
                                    <span class="blinking">
                                        <h5 align="center" slot="header">
                                            <i class="fa fa-angle-double-down"></i>
                                        </h5>
                                    </span>
                                </b-btn>
                            </template>
                            <template v-else>
                                <b-btn block href="#" id="bt-scroll-dissable" >
                                    <h5 align="center" slot="header">
                                        <pulse-loader :loading="feedLoading" :color="'gray'" :size="'10px'" ></pulse-loader>
                                    </h5>
                                </b-btn>
                            </template>
                        </template>
                    </div>
                </div>
            </template>
            <template v-else-if='Object.keys(feedResults).length'>
                <div class="row">
                    <div class="col-sm-10">
                        <table class="table table-hover" style="max-width: 70rem;min-width: 70rem;">
                          <thead>
                            <tr>
                              <th scope="col">Submitted</th>
                              <th scope="col">Sample</th>
                              <th scope="col">Children</th>
                              <th scope="col">Tags</th>
                              <th scope="col">Status</th>
                            </tr>
                          </thead>
                          <tbody>
                            <tr class="meta" v-for="(sample, index) in feedResults" :key="index" >
                                <td style="line-height: 1.5;">
                                    {{ sample.created | moment("DD/MM/YYYY")  }}
                                    <br>
                                    {{ sample.created | moment("HH:mm:ss")  }}
                                </td>
                                <!--td class="meta-bit"><b>{{ sample.sha256 }}</b></td-->
                                <td><a class="txtlink"  target="_blank" :href="'/results/'+sample.id"><b class="txtlink">{{ sample.sha256 }}</b></a></td>
                                <td>
                                    <template if="sample.status=='complete'">
                                        <template v-if="sample.children == 0 &&
                                                        !sample.downloader &&
                                                        !Object.keys(sample.malwareid).length">
                                            <b-badge pill style="pointer-events:none" class="nohover nochildren-pill"><b>{{sample.children}}</b></b-badge>
                                        </template>
                                        <template v-else>
                                            <b-badge pill style="pointer-events:none" class="nohover children-pill"><b>{{sample.children}}</b></b-badge>
                                        </template>
                                    </template>
                                </td>
                                <td style="line-height: 1.5;">
                                    <template v-if="sample.autoit">
                                        <b-badge pill style="pointer-events:none" v-bind:key="sample.autoit.id" class="nohover autoit-pill"><b>AutoIt</b></b-badge>
                                    </template>
                                    <template v-if="sample.downloader">
                                        <b-badge pill style="pointer-events:none" v-bind:key="sample.downloader.id" class="nohover downloader-pill"><b>Network Dropper</b></b-badge>
                                    </template>
                                    <template v-for="malwareidHit in sample.malwareid">
                                        <template v-if="malwareidHit.type =='malpedia'">
                                            <b-badge pill style="pointer-events:none" v-bind:key="malwareidHit.id" class="nohover malpedia-pill"><b>{{malwareidHit.match}}</b></b-badge>
                                        </template>
                                    </template>
                                    <template v-for="deepMatchHit in sample.deepmatch">
                                        <b-badge pill style="pointer-events:none" v-bind:key="deepMatchHit.id"  class="nohover deepmatch-pill"><b>{{deepMatchHit.label}}</b></b-badge>
                                    </template>
                                </td>
                              <td>
                                <span v-if="sample.status=='fail'">
                                    <b-badge type="pill" variant="danger" style="max-width: 10rem;min-width:6rem;pointer-events:none" class="nohover"><b>{{ sample.status }}</b></b-badge>
                                </span>
                                <span v-else-if="sample.status=='complete'">
                                    <b-badge type="pill" variant="success" style="max-width: 10rem;min-width:6rem;pointer-events:none"  class="nohover"><b>{{ sample.status }}</b></b-badge>
                                </span>
                                <span v-else-if="sample.status=='timeout'">
                                    <b-badge type="pill" variant="warning" style="max-width: 10rem;min-width:6rem;pointer-events:none"  class="nohover"><b>{{ sample.status }}</b></b-badge>
                                </span>
                                <span v-else>
                                    <b-badge type="pill" style="max-width: 10rem;min-width:6rem;pointer-events:none"  class="pill pill-secondary pill-sm nohover"><b>{{ sample.status }}</b></b-badge>
                                </span>
                              </td>
                            </tr>
                          </tbody>
                        </table>
                    </div>
                </div>
            </template>
        </template>
    </template>
    <!-- ######################### BUILD MOBILE VERSION ######################### -->
    <template v-else>
        <div class="row">
            <div class="col-sm-6">
                <h1 id="info-page">Live Feed
                    <small style="color:#b4bcc2;font-size:1.2rem;">
                        <a style="text-align:right;color:#6c757c;padding-right:4px;padding-bottom:2px;"><i id="lf-info" class="fa fa-info-circle"></i></a>
                    </small>
                </h1>
                <b-tooltip style="max-width: 500px!important;background-color: #fff !important;" triggers="click" target="lf-info" placement="topleft">
                    <div id="lf-tip">
                        This feed only represents a small subset of samples processed by UNPACME. The feed only contains samples submitted by our DEMO user and is intended for demonstration purposes only.
                        <br/><br/>
                        The feed is refreshed once an hour and trails behind the live results by about five hours.
                    </div>
                </b-tooltip>
            </div>
        </div>
        <div class="row">
            <div class="col-sm-10">
                <table class="table table-hover" style="table-layout: fixed;max-width: 21rem;min-width: 21rem;">
                  <thead>
                    <tr>
                      <th scope="col">Samples</th>
                    </tr>
                  </thead>
                  <tbody v-for="(sample, index) in feedResults" :key="index" >
                    <tr class="meta" style="line-height: 2;">
                        <td style="overflow: hidden;white-space: nowrap;text-overflow: ellipsis;"><a class="txtlink"  target="_blank" :href="'/results/'+sample.id"><b class="txtlink" style="font-size: 13px;">{{ sample.sha256 }}</b></a></td>
                    </tr>
                  </tbody>
                </table>
            </div>
        </div>
    </template>
</div>
</template>

<script>
import axios from 'axios';

export default {
    props: ['auth', 'authenticated'],
    data() {
        return {
            // For controlling the timer and status display
            feedResults: [],
            accessData: {},
            feedCursor: null,
            feedMore: true,
            feedLoading: true,
            yaraHits: {},
            yaraFilter: null,
            // my_timer: 0
        };
    },
    beforeCreate() {
        document.body.className = 'none';
    },
    metaInfo() {
        return {
            title: 'UnpacMe Live Feed',
            meta: [{ name: 'description', content: 'UnpacMe is an automated malware unpacking service. We provide malware analysis at Internet scale. Free for non-commercial use.' },
                { name: 'keywords', content: 'unpacking,unpacme,unpakme,unpackme,malware,malware analysis,analysis,automation,sandbox,oalabs,openanalysis,open analysis' }],
        };
    },
    methods: {
        getAccessAndFeed() {
            const tempBearer = this.getAuthBearer();
            const path = 'https://api.unpac.me/api/v1/private/user/access';
            axios.get(path, { headers: { Authorization: tempBearer } })
                .then((res) => {
                    //console.log(res.data);
                    this.accessData = res.data;
                    // Check if the user has full feed access
                    if(Object.keys(this.accessData).length && (this.accessData.roles.includes("feed") || this.accessData.roles.includes("admin"))){
                        this.getPrivateFeed();
                        this.getYaraHits();
                    }
                    else{
                        //Just load the normal feed
                        this.getFeed();
                    }
                })
                .catch((error) => {
                    // eslint-disable-next-line
                    console.error(error);
                    //Just load the normal feed
                    this.getFeed();
                });
        },
        getAuthBearer() {
            this.accessToken = localStorage.getItem('access_token') || null;
            return `Bearer ${this.accessToken}`;
        },
        isMobile() {
            if (navigator.userAgent.match(/Android/i) ||
            navigator.userAgent.match(/webOS/i) ||
            navigator.userAgent.match(/iPhone/i) ||
            // ipad is a full browser
            // navigator.userAgent.match(/iPad/i) ||
            navigator.userAgent.match(/iPod/i) ||
            navigator.userAgent.match(/BlackBerry/i) ||
            navigator.userAgent.match(/Windows Phone/i)) {
                console.log('is mobile');
                return true;
            }
            console.log('not mobile');
            return false;
        },
        getFeed() {
            this.feedLoading = true;
            const path = 'https://api.unpac.me/api/v1/public/feed';
            axios.get(path)
                .then((res) => {
                    this.feedResults = res.data.results;
                    this.feedLoading = false;
                })
                .catch((error) => {
                    // eslint-disable-next-line
                    console.error(error);
                    this.feedLoading = false;
                });
        },
        getPrivateFeed() {
            console.log("accessing private feed");
            this.feedLoading = true;
            const tempBearer = this.getAuthBearer();
            let feedUrl = '';
            if (this.feedMore) {
                if (this.feedCursor === null) {
                    feedUrl = 'https://api.unpac.me/api/v1/private/feed/unpacked';
                } else {
                    feedUrl = `https://api.unpac.me/api/v1/private/feed/unpacked?cursor=${this.feedCursor}`;
                }
                axios.get(feedUrl, { headers: { Authorization: tempBearer } })
                    .then((res) => {
                        // Sort the submissions from newest to oldest
                        var byDateSubmissions = res.data.submissions.slice(0);
                        byDateSubmissions.sort(function(a,b) {
                            return b.created - a.created ;
                        });
                        this.feedResults.push(...byDateSubmissions);
                        if(this.feedCursor === res.data.cursor){
                            this.feedMore = false;
                        }
                        this.feedCursor = res.data.cursor;
                        this.feedLoading = false;
                    })
                    .catch((error) => {
                        if (error.response.status === 404) {
                        // No more history just remove button
                            this.feedMore = false;
                        }
                        // eslint-disable-next-line
                        console.error(error);
                        this.feedLoading = false;
                    });
            }
        },
        getYaraHits() {
            const tempBearer = this.getAuthBearer();
            const yaraUrl = 'https://api.unpac.me/api/v1/private/feed/unpacked/yara';
            axios.get(yaraUrl, { headers: { Authorization: tempBearer } })
                .then((res) => {
                    this.yaraHits = res.data.malwareid;
                })
                .catch((error) => {
                    // eslint-disable-next-line
                    console.error(error);
                });

        },
        getYaraFeed() {
            this.feedLoading = true;
            const tempBearer = this.getAuthBearer();
            let yaraUrl = '';
            if (this.feedMore) {
                if (this.feedCursor === null) {
                    yaraUrl = `https://api.unpac.me/api/v1/private/feed/unpacked/yara/${this.yaraFilter}`;
                } else {
                    yaraUrl = `https://api.unpac.me/api/v1/private/feed/unpacked/yara/${this.yaraFilter}?cursor=${this.feedCursor}`;
                }
                axios.get(yaraUrl, { headers: { Authorization: tempBearer } })
                    .then((res) => {
                        // Sort the submissions from newest to oldest
                        var byDateSubmissions = res.data.submissions.slice(0);
                        byDateSubmissions.sort(function(a,b) {
                            return b.created - a.created ;
                        });
                        this.feedResults.push(...byDateSubmissions);
                        if(this.feedCursor === res.data.cursor){
                            this.feedMore = false;
                        }
                        this.feedCursor = res.data.cursor;
                        this.feedLoading = false;
                    })
                    .catch((error) => {
                        // eslint-disable-next-line
                        console.error(error);
                        if (error.response.status === 404) {
                        // No more history just remove button
                            this.feedMore = false;
                        }
                        // eslint-disable-next-line
                        console.error(error);
                        this.feedLoading = false;
                    });
            }

        },
        setYaraFilter(yaraRule) {
            console.log(yaraRule);
            if(this.yaraFilter === yaraRule){
                // Clear the filter and reset states
                this.yaraFilter = null;
                this.feedResults = [];
                this.feedCursor = null;
                this.feedMore = true;
                this.getPrivateFeed();
            }
            else{
                this.yaraFilter = yaraRule;
                // Reset count
                this.feedResults = [];
                this.feedCursor = null;
                this.feedMore = true;
                this.getYaraFeed()
            }
            

        },
        bulkDownload(sampleLink) {
            // const tempBearer = this.getAuthBearer();
            // axios({
            //     url: `https://api.unpac.me/api/v1/private/download/${sampleLink}`,
            //     headers: { Authorization: tempBearer },
            //     method: 'GET',
            //     responseType: 'blob', // important
            // }).then((response) => {
            //     const url = window.URL.createObjectURL(response.data);
            //     const link = document.createElement('a');
            //     link.href = url;
            //     link.setAttribute('download', `${sampleLink}.bin`); // or any other extension
            //     document.body.appendChild(link);
            //     link.click();
            // })
            //     .catch((error) => {
            //         if (error.response.status === 401) {
            //             this.showErrorMsg({ title: 'Download Not Authorized', message: '<br>Downloads are only permitted for the results of your own submissions. Please submit the parent for analysis.' });
            //         } else if (error.response.status === 404) {
            //             this.showErrorMsg({ title: 'Sample Not Found', message: '<br>Download is not available for this sample.' });
            //         } else {
            //             this.showErrorMsg({ title: 'Download Error', message: '<br>We are currently experiencing some technical difficulties with the download.' });
            //         }
            //     });
        },
        clickGoTo(sample) {
            // window.location.href = "/results/"+sample.id;
            window.open(
                `/results/${sample.id}`,
                '_blank', // <- This is what makes it open in a new window.
            );
        },
    },
    created() {
        if (this.authenticated) {
            this.getAccessAndFeed();
        }
        else{
            this.getFeed();
        }

        // this.my_timer = setInterval(this.getFeed, 90000)
    },
    beforeDestroy() {
        // Clear the timer
        // clearInterval(this.my_timer)
    },
};
</script>




// WEBPACK FOOTER //
// src/components/Feed.vue